import { createSelector } from '@ngrx/store'
import { TemplateTypeState } from '../reducers/template-type.reducer'

export const selectedTemplateTypeState = (state): TemplateTypeState => state.equipmentState.templateType

export const templateTypes = createSelector(selectedTemplateTypeState, types => types.templateTypes)
